import React, { useState, useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import PrivateRoute from './components/PrivateRoute';
import { lazyWithRetry } from './utils/lazyWithRetry';
import './App.css';

const Home = lazy(() => lazyWithRetry(() => import('./pages/Home')));
const SignIn = lazy(() => lazyWithRetry(() => import('./pages/SignIn')));
const BlogDetail = lazy(() => lazyWithRetry(() => import('./pages/BlogDetail')));
const CreateBlog = lazy(() => lazyWithRetry(() => import('./pages/CreateBlog')));
const MyBlogs = lazy(() => lazyWithRetry(() => import('./pages/MyBlogs')));
const AdminPanel = lazy(() => lazyWithRetry(() => import('./pages/AdminPanel')));
const About = lazy(() => lazyWithRetry(() => import('./pages/About')));
const ContactUs = lazy(() => lazyWithRetry(() => import('./pages/ContactUs')));

function App() {
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'dark');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  };

  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Navbar theme={theme} toggleTheme={toggleTheme} />
          <main className="main-content">
            <Suspense fallback={
              <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                minHeight: '60vh',
                fontSize: '18px',
                color: 'var(--text-color)'
              }}>
                Loading...
              </div>
            }>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/signin" element={<SignIn />} />
                <Route path="/blog/:id" element={<BlogDetail />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/create-blog" element={<PrivateRoute><CreateBlog /></PrivateRoute>} />
                <Route path="/edit-blog/:id" element={<PrivateRoute><CreateBlog /></PrivateRoute>} />
                <Route 
                  path="/my-blogs" 
                  element={
                    <PrivateRoute>
                      <MyBlogs />
                    </PrivateRoute>
                  } 
                />
                <Route 
                  path="/admin" 
                  element={
                    <PrivateRoute>
                      <AdminPanel />
                    </PrivateRoute>
                  } 
                />
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;

